import React, { Fragment, FunctionComponent } from 'react';
import "../error.scss"
import Text from '../../../components/typography/typgraphy';

const OperAccountNotValid: FunctionComponent = ({operAccount}) => {
  return (
    <Fragment>
      <Text className="error-description">Your account {operAccount} seems to be closed or not valid.</Text>
    </Fragment>
  )
}

export default OperAccountNotValid;